import type { CookieOptions } from './types';

// ----------------------------------------------------------------------------

function escapeRegExp(value: string): string {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function buildCookieString(name: string, value: string, options: CookieOptions = {}): string {
    const items = [`${encodeURIComponent(name)}=${encodeURIComponent(value)}`];

    items.push(`path=${options.path ?? '/'}`);

    if (typeof options.days === 'number') {
        const expires = new Date();

        expires.setTime(expires.getTime() + 24 * 60 * 60 * 1000 * options.days);

        items.push(`expires=${expires.toUTCString()}`);
    }

    if (typeof options.maxAge === 'number') {
        items.push(`max-age=${options.maxAge}`);
    }

    if (options.domain) {
        items.push(`domain=${options.domain}`);
    }

    if (options.sameSite) {
        items.push(`samesite=${options.sameSite}`);
    }

    if (options.secure) {
        items.push('secure');
    }

    return items.join(';');
}

function normalizeSetOptions(daysOrOptions: number | CookieOptions = 3): CookieOptions {
    if (typeof daysOrOptions === 'number') {
        return {
            days: daysOrOptions,
        };
    }

    return daysOrOptions;
}

// ----------------------------------------------------------------------------

export { escapeRegExp, buildCookieString, normalizeSetOptions };
